import type { IVRInfo } from "../../../sales-context/SalesContext.types";
import type { CallIntroStep } from "../../../stores/useCallIntroStore";
import type { CustomerVerificationStep } from "../../../stores/useVerificationFlowStore";

import { isIVRHandoffStep } from "../components/customer-handoff/isIVRHandoffStep";

export function calcIsEditing(params: {
    isCustomerFlowComplete: boolean;
    stepHistory: string[];
    callIntroStepHistory: string[];
}) {
    const { isCustomerFlowComplete, stepHistory, callIntroStepHistory } = params;
    return (
        !isCustomerFlowComplete &&
        (stepHistory.includes("VerificationComplete") || callIntroStepHistory.includes("IntroFlowCompleted"))
    );
}

export function calcShouldShowCustomerProfile(params: {
    isChat: boolean;
    isCustomerFlowComplete: boolean;
    isEditing: boolean;
    callIntroStep: CallIntroStep;
    stepHistory: CustomerVerificationStep[];
    isEnhancedCustomerSearchEnabled: boolean;
    ivrInfo: IVRInfo | undefined;
}) {
    const {
        isChat,
        isCustomerFlowComplete,
        isEditing,
        callIntroStep,
        stepHistory,
        isEnhancedCustomerSearchEnabled,
        ivrInfo,
    } = params;

    return (
        isChat ||
        isCustomerFlowComplete ||
        isEditing ||
        !isIVRHandoffStep({ callIntroStep, stepHistory, isEnhancedCustomerSearchEnabled, ivrInfo })
    );
}
